import { z } from 'zod';
import type { CityToken } from '@sleed/bizcommerce-api';

/**
 * City edit form. Mirrors `CityToken` and the legacy admin grid
 * (Core/client/admin/src/pages/System/Cities/index.js): crid (region) required, nm required ≤100,
 * cd ≤50. `erpcd` is carried through so an update never wipes it.
 */
export const citySchema = z.object({
	id: z.number().optional(),
	crid: z.number().int().positive('validation.required'),
	nm: z.string().trim().min(1, 'validation.required').max(100, 'validation.tooLong'),
	cd: z.string().trim().max(50, 'validation.tooLong').nullable(),
	iv: z.boolean(),
	si: z.number({ message: 'validation.required' }).int(),
	erpcd: z.string().nullable()
});

export type CityFormValues = z.infer<typeof citySchema>;

export const EMPTY_CITY: CityFormValues = { crid: 0, nm: '', cd: null, iv: true, si: 0, erpcd: null };

export function tokenToForm(token: CityToken): CityFormValues {
	return {
		id: token.id,
		crid: token.crid ?? 0,
		nm: token.nm ?? '',
		cd: token.cd ?? null,
		iv: token.iv ?? false,
		si: token.si ?? 0,
		erpcd: token.erpcd ?? null
	};
}

export function formToToken(form: CityFormValues): CityToken {
	return {
		id: form.id,
		crid: form.crid,
		nm: form.nm.trim(),
		cd: form.cd?.trim() || null,
		iv: form.iv,
		si: form.si,
		erpcd: form.erpcd
	};
}
